module.exports = __webpack_public_path__ + "img/pr-4.f23fb53f.png";